import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | boolean;
}

/**
 * Service to confirm on unsaved forms.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    canDeactivate(component: CanComponentDeactivate) {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/can-deactivate.service.ts